"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Range_1 = __importDefault(require("../../../Util/Range"));
const TrainingInterface_1 = require("../../../BusinessLogicLayer/TrainingInterface");
const iterateDateRange_1 = __importDefault(require("../../../BusinessLogicLayer/iterateDateRange"));
const calculateWeek_1 = __importDefault(require("../calculateWeek"));
const flatArray_1 = require("../../../Util/flatArray");
const clock_1 = require("@almservices-cl/clock");
class WeekPlanRepository {
    constructor(dateTimeModifier, graphqlClient, customerClient, cacheStrategy, dateTimeProvider, logger, periodPicker) {
        this.areArgsFromSameSubscription = (args) => {
            if (args.length === 1)
                return true;
            return args[0].periodId === args[1].periodId;
        };
        this.reduceSubscriptionWeeks = (args) => {
            return args.reduce((acc, arg) => [...acc, arg.week], []);
        };
        this.getWeekPlanForMultiSubscriptions = async (args) => {
            const promises = [];
            if (this.areArgsFromSameSubscription(args)) {
                promises.push(this.graphqlClient.fetch("weekDayTypesForWeek", this.buildQuery(this.reduceSubscriptionWeeks(args)), {
                    subscriptionId: args[0].periodId,
                }));
            }
            else {
                args.forEach((arg) => {
                    promises.push(this.graphqlClient.fetch("weekDayTypesForWeek", this.buildQuery([arg.week]), {
                        subscriptionId: arg.periodId,
                    }));
                });
            }
            const res = await Promise.all(promises);
            const days = res
                .map((response) => Object.values(response).reduce(flatArray_1.flatArray, []))
                .reduce(flatArray_1.flatArray, []);
            return {
                days,
            };
        };
        this.getWeekPlanForDateRange = async (range, customerId, weeks, subscriptionId) => {
            const daysToTypes = await this.cacheStrategy.get(`WeekPlanForDateRange.${customerId}`, async (prev) => {
                if (this.dateTimeModifier.daysDiff(this.dateTimeProvider.currentRaw(clock_1.UTCTimeZone.z()).date, range.to) >= 0) {
                    return true;
                }
                let notFound = false;
                (0, iterateDateRange_1.default)(range, this.dateTimeModifier, this.dateTimeProvider, (date) => {
                    if ((prev === null || prev === void 0 ? void 0 : prev[date]) === undefined) {
                        notFound = true;
                    }
                });
                return notFound;
            }, async (prev) => {
                const daysToTypes = prev || {};
                const data = await this.graphqlClient.fetch("weekDayTypesForWeek", this.buildQuery(weeks), {
                    subscriptionId,
                });
                Object.keys(data).forEach((weekKey) => {
                    data[weekKey].forEach(({ date, dayType }) => {
                        daysToTypes[this.dateTimeProvider.fromDateTimeToDate(date)] =
                            dayType;
                    });
                });
                return daysToTypes;
            });
            const days = [];
            (0, iterateDateRange_1.default)(range, this.dateTimeModifier, this.dateTimeProvider, async (date) => {
                if (daysToTypes[date] === undefined) {
                    this.logger.log(`There are no info about training day in ${date}`);
                }
                days.push({
                    date,
                    dayType: daysToTypes[date] || TrainingInterface_1.WeekDayType.RECOVERY,
                });
            });
            return {
                days,
            };
        };
        this.getDayType = async (customerId, date) => {
            const customer = await this.customerClient.getCustomer(customerId);
            const period = this.periodPicker.pickPeriod(customer.periods, new Range_1.default(date, date));
            const day = this.dateTimeModifier.daysDiff(period.startDate, date) + 1;
            const week = (0, calculateWeek_1.default)(day);
            const weekPlan = await this.getWeekPlanForDateRange(new Range_1.default(date, date), customerId, [week], period.periodId);
            return weekPlan.days[0].dayType;
        };
        this.dateTimeModifier = dateTimeModifier;
        this.graphqlClient = graphqlClient;
        this.customerClient = customerClient;
        this.cacheStrategy = cacheStrategy;
        this.dateTimeProvider = dateTimeProvider;
        this.logger = logger;
        this.periodPicker = periodPicker;
    }
    buildQuery(weeks) {
        const subqueries = weeks.map((week) => `        week${week}: progressCollection(subscriptionId: $subscriptionId, week: ${week}) {
          date
          dayType
        }\n`);
        return `
      query ($subscriptionId: Int!){
        ${subqueries}
      }
    `;
    }
}
exports.default = WeekPlanRepository;
//# sourceMappingURL=WeekPlanRepository.js.map